import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { MASTER_LANGS, LEGACY_DEFAULT } from '../i18n/languages';

// `allowed` = ordered list of language codes this venue shows diners (primary first).
// When omitted/empty we fall back to the legacy en/th/ru set. A single language hides the switcher.
function LanguageSwitcher({ allowed }) {
  const { lang, setLang } = useLanguage();
  const codes = (allowed && allowed.length) ? allowed : LEGACY_DEFAULT;
  const langs = codes.map((c) => MASTER_LANGS.find((l) => l.code === c)).filter(Boolean);
  if (langs.length <= 1) return null;

  return (
    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
      {langs.map(({ code, label }) => (
        <button
          key={code}
          onClick={() => setLang(code)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '0.875rem',
            fontWeight: lang === code ? '700' : '400',
            color: lang === code ? '#d97757' : '#555',
            borderBottom: lang === code ? '2px solid #d97757' : '2px solid transparent',
            transition: 'color 0.15s, border-color 0.15s',
            minWidth: '44px',
            minHeight: '44px',
            lineHeight: '44px',
            padding: '0 8px',
          }}
          aria-current={lang === code ? true : undefined}
          aria-label={`Switch to ${label}`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageSwitcher;
